import React, { useState, useEffect } from 'react';

import FatigueGraphsModule from '../modules/FatigueGraphsModule';
import './Box.css';

const QiFatigueGraphsBox = ({user, isSmallScreen}) => {

    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>

            <h4></h4>

            <FatigueGraphsModule
                user={user}
                isSmallScreen={isSmallScreen}
            />

        </div>
    );
};

export default QiFatigueGraphsBox;

